import { useEffect, useId, useState } from 'react'
import { MAX_PROJECT_SYSTEMS, todayIso } from '../../../shared/projects.js'
import { useSystems } from '../../lib/queries/systems.js'
import { Dialog } from '../ui/Dialog.jsx'
import styles from './projects.module.css'

const EMPTY = { name: '', client: '', owner: '', startOn: '', systems: [] }

/** Create a project and pick the systems in scope; each gets its Day-0 checklist. */
export function NewProjectDialog({ open, onClose, onCreate, busy }) {
  const systems = useSystems()
  const formId = useId()
  const [form, setForm] = useState(EMPTY)
  useEffect(() => {
    if (open) setForm({ ...EMPTY, startOn: todayIso() })
  }, [open])

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }))
  const toggle = (slug) =>
    setForm((f) => ({ ...f, systems: f.systems.includes(slug) ? f.systems.filter((s) => s !== slug) : f.systems.length < MAX_PROJECT_SYSTEMS ? [...f.systems, slug] : f.systems }))
  const valid = form.name.trim().length >= 2 && form.client.trim() && form.startOn

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="New project"
      description="Pick the systems in scope. Each one starts with its Day-0 credential checklist."
      width={540}
      footer={
        <>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" form={formId} className="btn btn-dark" disabled={!valid || busy}>
            Create project
          </button>
        </>
      }
    >
      <form
        id={formId}
        className={styles.formOne}
        onSubmit={(e) => {
          e.preventDefault()
          if (valid) onCreate({ name: form.name.trim(), client: form.client.trim(), owner: form.owner.trim(), startOn: form.startOn, systems: form.systems })
        }}
      >
        <label className="field">
          <span>Project name</span>
          <input autoFocus value={form.name} maxLength={120} placeholder="e.g. Northwind P21 to Commerce" onChange={set('name')} />
        </label>
        <label className="field">
          <span>Client</span>
          <input value={form.client} maxLength={120} onChange={set('client')} />
        </label>
        <label className="field">
          <span>Owner</span>
          <input value={form.owner} maxLength={80} placeholder="Who runs the weekly call" onChange={set('owner')} />
        </label>
        <label className="field">
          <span>Start date</span>
          <input type="date" value={form.startOn} onChange={set('startOn')} />
        </label>
        <fieldset style={{ border: 0, padding: 0, margin: 0 }}>
          <legend className={styles.fieldLabel} style={{ marginBottom: 6 }}>
            Systems in scope
          </legend>
          <div className={styles.sysOpts}>
            {(systems.data ?? []).map((s) => (
              <label key={s.slug} className={styles.sysOpt}>
                <input type="checkbox" checked={form.systems.includes(s.slug)} onChange={() => toggle(s.slug)} />
                <span>
                  {s.name} {s.vendor ? <span className={styles.muted}>· {s.vendor}</span> : null}
                </span>
              </label>
            ))}
          </div>
        </fieldset>
      </form>
    </Dialog>
  )
}
